import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ProfileFormData } from '../../../profile/schemas/profile.schema';
import { getDocumentType } from '../../../users/utils/masks';
import api from '../../http';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';

export interface UpdateProfilePayload {
	formData?: Partial<ProfileFormData>;
	avatarFile?: File;
	backgroundFile?: File;
	password?: string;
	confirmPassword?: string;
}

export const useUpdateProfile = (
	forBindingParams: { forBinding: string } | Record<string, never> = {}
) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (data: UpdateProfilePayload) => {
			try {
				const { formData, avatarFile, backgroundFile, password, confirmPassword } = data;
				const documentType = getDocumentType(formData?.document);

				const form = createFormData({
					...formData,
					documentType,
					avatar: avatarFile,
					background: backgroundFile,
					password,
					confirmPassword,
				});

				return (await api.put('/user/updateProfile', form, { params: forBindingParams })).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar perfil');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['me'],
			});
		},
		onError: (error) => {
			console.error(
				'Erro ao atualizar perfil:',
				getApiErrorMessage(error, 'Erro ao atualizar perfil')
			);
		},
	});
};
